import React from "react";
import LegalShell, { LegalBlock } from "../components/LegalShell";

export default function Impressum() {
  return (
    <LegalShell title="Impressum">
      <LegalBlock title="Angaben gemäß § 5 TMG">
        <p>
          all about artists<br />
          Sebastian Lang<br />
          Schöttlestraße 22<br />
          70597 Stuttgart
        </p>
      </LegalBlock>

      <LegalBlock title="Kontakt">
        <p>
          Telefon: +49 711 72607514<br />
          E-Mail:{" "}
          <a className="text-[var(--crtr-yellow)] underline underline-offset-2" href="mailto:info@all-about-artists.de">
            info@all-about-artists.de
          </a>
        </p>
      </LegalBlock>

      <LegalBlock title="Umsatzsteuer-ID">
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
          DE209764382
        </p>
      </LegalBlock>

      <LegalBlock title="EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a className="text-[var(--crtr-yellow)] underline underline-offset-2" href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">
            https://ec.europa.eu/consumers/odr/
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </LegalBlock>

      <LegalBlock title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </LegalBlock>

      <LegalBlock title="Haftung für Inhalte">
        <p>
          Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
        </p>
      </LegalBlock>

      <LegalBlock title="Haftung für Links">
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
          Einfluss haben. Für diese fremden Inhalte ist stets der jeweilige Anbieter oder
          Betreiber der Seiten verantwortlich.
        </p>
      </LegalBlock>

      <LegalBlock title="Urheberrecht">
        <p>
          Die auf diesen Seiten veröffentlichten Inhalte und Werke unterliegen dem deutschen
          Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.
        </p>
      </LegalBlock>

      <LegalBlock title="Kennzeichnung von KI-Inhalten">
        <p>
          Einzelne Bildmotive auf dieser Website wurden mit Unterstützung künstlicher Intelligenz
          (KI) erstellt bzw. bearbeitet und sind direkt am jeweiligen Bild dezent mit dem Hinweis
          „KI-generiert“ gekennzeichnet. Dies betrifft derzeit die Kampagnen- und Produktbilder der
          Marke Schlafi (Case „Schlafi“) sowie das Profilbild der Creator „Die Lockenköpfe“. Alle
          übrigen Fotos und Videos sind ohne KI-Unterstützung entstanden.
        </p>
      </LegalBlock>
    </LegalShell>
  );
}
